import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import App from './App'
import store from './store'

Drupal.behaviors.electionsStats = {
  attach: function(context, settings) {
    once('renderStatsApp', '#' + settings.electionsStats.mountPointID, context).forEach((element) => {
      ReactDOM.render(
        <Provider store={store}>
          <App app={settings.electionsStats.app} settings={settings.electionsStats.appSettings} />
        </Provider>,
        document.getElementById(settings.electionsStats.mountPointID)
      )
    });
  }
}
